import { render, staticRenderFns } from "./DateEditorRequest.vue?vue&type=template&id=540ca4da&scoped=true&"
import script from "./DateEditorRequest.vue?vue&type=script&lang=js&"
export * from "./DateEditorRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ca4da",
  null
  
)

export default component.exports